<template>
    <transition name="modal-fade">
        <div class="modal donation">
            <a href="javascript:;" type="button" class="close-modal-button" data-dismiss="modal" aria-label="Close" @click="closeModal">
                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
            </a>
            <div class="modal-dialog modal-dialog-centered donation-dialog">
                <div class="row w-100 donation-content no-gutters" v-if="donationData">
                    <div class="col-12 col-md-7 px-4 pl-md-0 mb-4 mb-md-0">
                        <div
                            class="bg-white overflow-hidden donation-left h-100"
                        >
                            <carousel v-if="donationData.images.length > 0" :per-page="1"
                                      :autoplay="true"
                                      :autoplayTimeout="4000"
                                        :loop="true"
                                      :paginationEnabled="false"
                                      :mouse-drag="false">
                                <slide v-for="(image, index) in donationData.images" v-bind:key="index">
                                    <img
                                        :src="image"
                                        alt=""
                                        class="img-fluid d-block w-100"
                                    />
                                </slide>
                            </carousel>
                            <div class="p-4">
                                <img
                                    :src="donationData.fund_logo"
                                    alt=""
                                    class="d-block"
                                    style="height: 50px;"
                                />
                                <h2 class="my-2 donation-left-title">
                                    {{ donationData.title }}
                                </h2>
                                <div class="donation-left-desc mb-2">
                                    {{ donationData.about_short }}
                                </div>
                                <div
                                    v-if="donationData.about_campaign"
                                    @click="toggleReadMoreModal"
                                    class="donation-left-link d-inline-block"
                                >
                                    Read more...
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-5 px-4 px-md-0">
                        <div
                            class="bg-white overflow-hidden donation-right p-4 h-100"
                        >
                            <SecuredDonation
                                v-if="step === 1"
                                @changeStep="changeStep"
                                @updateData="updateStep1Data"
                                :donation-data="donationData"
                                :donation-form-data="donationForm.step1"
                            />

                            <CreditCard
                                ref="creditCardRef"
                                :step="step"
                                @changeStep="changeStep"
                                :donation-data="donationData"
                                :donation-form="donationForm"
                                @setTilled="tilledInstance = $event"
                                @checkPaymentStatus="checkForTilledPaymentStatus($event)"
                                @checkMonthlyPaymentStatus="checkForTilledMonthlyPaymentStatus($event)"
                            />

                            <PersonalInformation
                                v-if="step === 3"
                                @changeStep="changeStep"
                                :country_codes="country_codes"
                                @updateData="updateStep3Data"
                                :donation-form-data="donationForm.step3"
                            />
                            <MailingAddress
                                v-if="step === 4"
                                :donate-amount="toCurrency(parseInt(donationForm.step1.donateAmount) + fee)"
                                :donation-data="donationData"
                                @changeStep="changeStep"
                                :states="states"
                                :country_codes="country_list"
                                :donation-form-data="donationForm.step4"
                                @updateData="updateStep4Data"
                            />
                            <AdditionalInformation
                                v-if="donationData.questions.length > 0 && step === 5"
                                @changeStep="changeStep"
                                :donate-amount="toCurrency(parseInt(donationForm.step1.donateAmount) + fee)"
                                :donation-data="donationData"
                                :donation-form-data="donationForm.step5"
                                @updateData="updateStep5Data"
                            />
                            <ThankYou
                                v-if="step === 6"
                                :donation-data="donationData"
                                @close="closeModal" />
                        </div>
                    </div>
                </div>
            </div>
            <ReadMoreModal
                @close="toggleReadMoreModal"
                :title="donationData.title"
                :content="donationData.about_campaign"
                v-if="donationData && isShowReadMoreModal"
            />
        </div>
    </transition>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import SecuredDonation from '@/commons/DonationModal/SecuredDonation.vue';
import CreditCard from '@/commons/DonationModal/CreditCard.vue';
import PersonalInformation from '@/commons/DonationModal/PersonalInformation.vue';
import MailingAddress from '@/commons/DonationModal/MailingAddress.vue';
import AdditionalInformation from '@/commons/DonationModal/AdditionalInformation.vue';
import ThankYou from '@/commons/DonationModal/ThankYou.vue';
import ReadMoreModal from '@/commons/DonationModal/ReadMoreModal.vue';
import DibbleApi from "@/api";
import DibbleJs from "@/dibble";
import DibbleJS from "@/dibble";

export default {
    name: 'CampaignDonationModal',
    computed: {
        fee() {
            return this.donationForm.step1.isNotCoveredFee ? 0 : this.donationData.transaction_fee + Math.round(parseInt(this.donationForm.step1.donateAmount) * this.donationData.discount_fee_pc) / 100;
        },
    },
    components: {
        SecuredDonation,
        CreditCard,
        PersonalInformation,
        MailingAddress,
        AdditionalInformation,
        ThankYou,
        ReadMoreModal,
        Carousel, Slide,
    },
    data() {
        return {
            campaign_id: '',
            distribution_id: '',
            donationData: null,
            step: 1,
            donate: '',
            isShowReadMoreModal: false,
            states: [],
            country_codes: [],
            country_list: [],

            donationForm: {
                step1: {
                    donateType: 1, // 1: Once, 2: Monthly
                    donateAmount: 0,
                    isDedicatedDonation: false,
                    isNotCoveredFee: false,
                    dedicateTo: '',
                    comment: '',
                    designation: '',
                },
                step2: {
                    cardNumber: '',
                    expire: '',
                    cvv: '',
                },
                step3: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    phoneNumber: '',
                    country: 'US',
                    isAnonymously: false,
                    isAnOrganization: false,
                    organizationName: '',
                },
                step4: {
                    address: '',
                    address2: '',
                    city: '',
                    zipCode: '',
                    state: '',
                    country: 'US',
                },
                step5: {
                    questions: [],
                }
            },
            tilledInstance: null,
        };
    },
    watch: {
        campaign_id(val) {
            if (val) {
                this.getCampaignDonationData()
            }
        },
        donationForm: {
            handler(val) {
                console.log('Donation Form: ', val)
            },
            deep: true,
        },
    },
    created() {
      this.campaign_id = this.$route.params.id;
      this.distribution_id = this.$route.query.distribution_id;
      this.getCountryCodes()
        this.getStates()
    },
    methods: {
        getCampaignDonationData() {
            const data = {
                '#request': DibbleApi.api.campaignGetDonationData,
                campaign_id: this.campaign_id,
                distribution_id: this.distribution_id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.donationData = response;
                } else {
                    alert('Unable to load content');
                    this.$emit('clickOutsideBody');
                }
                DibbleJs.hideLoader();
            });
        },
        getCountryCodes() {
            const params = {
                '#request': DibbleApi.api.getCountryCodes,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { countries } = response;
                    if (countries.length) {
                        this.country_codes = countries.map((item) => ({
                            value: item.country_code,
                            label: `+ ${item.dialing_code} (${item.name})`,
                            show_label: `+ ${item.dialing_code} (${item.country_code})`,
                        }));

                        this.country_list = countries.map((item) => ({
                            value: item.country_code,
                            label: item.name,
                        }));
                    }
                }
            });
        },
        getStates() {
            const params = {
                '#request': DibbleApi.api.getStateList,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const { states } = response;
                    if (states.length) {
                        this.states = states.map((item) => ({
                            value: item.state_code,
                            label: item.name,
                        }));
                        this.state = states.find(
                            (state) => state.state_code === 'NY'
                        ).state_code;
                    }
                }
            });
        },
        closeModal() {
            this.$emit('clickOutsideBody');
        },
        checkForTilledPaymentStatus(secret) {
            const params = {
                '#request': DibbleApi.api.tilledGetPaymentStatus,
                campaign_id: this.campaign_id,
                client_secret: secret
            }

            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response) && !response.is_failed) {
                    this.step = 6;
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                }
                DibbleJs.hideLoader()
            });
        },
        checkForTilledMonthlyPaymentStatus(data) {
            const params = {
                '#request': DibbleApi.api.tilledGetSubscriptionStatus,
                campaign_id: this.campaign_id,
                client_secret: data.secret,
                payment_method_id: data.paymentMethodId,
            }

            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response) && !response.is_failed) {
                    this.step = 6;
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                }
                DibbleJs.hideLoader()
            });
        },
        async confirmPayment(secret, phone_number) {
            console.log('Confirming payment...');
            await this.$refs.creditCardRef.confirmPayment(secret, phone_number);
        },
        performValidation() {
            const params = {
                campaign_id: this.campaign_id,
                designation_id: this.donationForm.step1.designation,
                distribution_id: this.distribution_id,
                amount: this.donationForm.step1.donateAmount,
                first_name: this.donationForm.step3.firstName,
                last_name: this.donationForm.step3.lastName,
                business_name: this.donationForm.step3.organizationName,
                email: this.donationForm.step3.email,
                phone_num: this.donationForm.step3.phoneNumber,
                country_code: this.donationForm.step3.country,
                address1: this.donationForm.step4.address,
                address2: this.donationForm.step4.address2,
                city: this.donationForm.step4.city,
                state: this.donationForm.step4.state,
                zip_code: this.donationForm.step4.zipCode,
                country: this.donationForm.step4.country,
                dedication: this.donationForm.step1.dedicateTo,
                is_anonymous: this.donationForm.step3.isAnonymously,
                comment: this.donationForm.step1.comment,
                is_monthly: this.donationForm.step1.donationType === 2,
                is_cover_fees: !this.donationForm.step1.isNotCoveredFee,
            }

            if (this.donationForm.step5.questions.length > 0) {
                const questions = [];
                this.donationForm.step5.questions.forEach((question) => {
                    questions.push({
                        question_id: question.question_id,
                        answer: question.answer,
                    });
                });

                params.questions = questions;
            }

            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.widgetDonationWithTilled,
                ...params,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    const { client_secret, phone_number } = response;
                    this.confirmPayment(client_secret, phone_number);
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                    DibbleJs.hideLoader();
                }

            });
        },
        changeStep(step) {
            if (step === 6) {
                this.performValidation()
            } else {
                this.step = step;
            }
        },
        updateStep1Data(value) {
            this.donationForm.step1 = value;
        },
        updateStep2Data(value) {
            this.donationForm.step2 = value;
        },
        updateStep3Data(value) {
            this.donationForm.step3 = value;
        },
        updateStep4Data(value) {
            this.donationForm.step4 = value;
        },
        updateStep5Data(value) {
            this.donationForm.step5 = value;
        },
        toggleReadMoreModal() {
            this.isShowReadMoreModal = !this.isShowReadMoreModal;
        },
        toCurrency(number) {
            return `$${new Intl.NumberFormat().format(number)}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.donation {
    background-color: rgba(0, 0, 0, 0.5);
    &-dialog {
        max-width: 900px !important;
        width: 100%;
    }
    &-content {
        pointer-events: auto;
    }
    &-left {
        border-radius: 12px;
        @media screen and (min-width: 900px) {
            min-height: 640px;
        }
        &-title {
            color: #2178ab;
            font-weight: 700;
            font-size: 22px;
        }
        &-desc {
            font-size: 16px;
            color: #555e67;
        }
        &-link {
            font-size: 16px;
            font-weight: 700;
            color: #41b8dc;
            cursor: pointer;
        }
    }
    &-right {
        border-radius: 12px;
    }
}
.close-modal-button {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}
</style>

<style lang="scss">
.donation-title {
    color: #2178ab;
    font-weight: 700;
    font-size: 22px;
}
.donation-desc {
    font-size: 16px;
    color: #7c7c7a;
}
.donation-back-icon {
    position: absolute;
    top: 8px;
    cursor: pointer;
}
</style>
